import { Edit, useTranslate } from "react-admin"
import FormInput from "./FormInput"


const NumberRangeEdit = () => {

  const translate = useTranslate()

  return (
    <Edit redirect="list" title={translate("resources.numberRanges.name", {smart_count: 1})}>
      <FormInput context="edit" />
    </Edit>
  )
}

export default NumberRangeEdit